import type { RawComment, Comment } from './types'
import { formatISOStringToUTC } from 'ui-component-library/utils/helpers'

export default function parse(rawComment: RawComment): Comment {
  const {
    id,
    edited,
    commenter,
    text,
    created,
    replies,
    commenterName,
    commenterUserid,
    topic,
    parent,
  } = rawComment

  // console.log('replies', replies)
  return {
    id: String(id),
    author: {
      name: commenter ? commenter.name : commenterName || '',
      userId: commenter ? String(commenter.userid) : String(commenterUserid),
    },
    text,
    createdAt: new Date(formatISOStringToUTC(created)),
    wasEdited: edited,
    replies: replies ? replies.map(parse) : [],
    topicId: topic && topic.tileId,
    parentId: parent && parent.id,
  }
}
